import axios from "axios"

import native from './native'
import * as util from "./util"
import cookie from './cookie'
import {getCookie, getACCESS_TOKEN} from "./util";

let b = util.getBrowser()


/**
 * customer 客户端调用接口
 * @type {AxiosInstance}
 */
var customer = axios.create({
  baseURL: '/hisapi/customer',
  timeout: 5000,
  headers: {
    "Accept": "application/json;charset=UTF-8",
    "Auth": JSON.stringify(util.getAuth()),
    "ACCESS_TOKEN": getACCESS_TOKEN()
  },
  responseType: 'json',
  withCredentials: true
});


customer.interceptors.request.use(function (config) {
  config = {
    ...config,
    _v: Date.now()
  }
  return config
}, function (error) {
  return Promise.reject(error);
})

// Add a response interceptor
customer.interceptors.response.use(function (response) {
  // handle login redirect
  if (response && response.data.code == -330004) {
    if (b.isapp) {
      native.oasislogin();
    } else {
      globle_vue.$router.replace({
        name: 'login',
        query: {url: globle_vue.$router.currentRoute.fullPath}
      })
    }

  }
  // if (response && response.data && response.data.success) {
  if (response && response.data) {
    if (response.data.code === 200) { // his 给的数据是规范
      return response.data
    }
  }
  let error = new Error()
  error.code = response.data.code
  error.message = response.data.message
  error.requrl = response.config.url
  throw error
}, function (error) {

  if (error.response && error.response.data) {
    let code = error.response.data.code;
    if (code == -330004) {
      if (b.isapp) {
        native.oasislogin();
      } else {
        globle_vue.$router.replace({
          name: 'login',
          query: {url: globle_vue.$router.currentRoute.fullPath}
        })
      }
    } else {
      // if(error.response && error.response.data && error.response.data.message){
      //   globle_vue.$vux.toast.text(error.response.data.message, 'center');
      // }
    }
  }

  let err = new Error()
  // handle timeout
  if (error.config.method == 'get' && error.message.indexOf('timeout') == 0) {
    let retry = error.config['retry'] || 1
    if (retry >= 3) {
      err.code = 400
      err.message = '网络异常，请稍后再试!'
    } else {
      // 解决base url的问题
      // error.config.url = error.config.url.replace(/\/api/g, '')
      console.log('yann1 请求异常重试', error.config)
      error.config['retry'] = retry + 1
      return instance.request(error.config)
    }
  } else {

    // handle other error
    err.code = 500
    err.message = '服务器异常，请稍后再试!'
    if (error && error.response) {
      if (error.response.data) {
        let data = error.response.data
        err.code = data.code || 500
        err.message = data.message || '服务器异常，请稍后再试!'
      } else if (error.response.status !== 500) {
        err.code = 400
        err.message = '网络异常，请稍后再试!'
      }
    }
  }
  return Promise.reject(err)
})
//---------customer end --------------------------

/**
 * register 客户端调用接口
 * @type {AxiosInstance}
 */
var register = axios.create({
  baseURL: '/hisapi/register',
  timeout: 5000,
  headers: {
    "Accept": "application/json;charset=UTF-8",
    "Auth": JSON.stringify(util.getAuth()),
    "ACCESS_TOKEN": getACCESS_TOKEN()
  },
  responseType: 'json',
  withCredentials: true
});

var hospital = axios.create({
  baseURL: '/hisapi/',
  timeout: 5000,
  headers: {
    "Accept": "application/json;charset=UTF-8",
    "Auth": JSON.stringify(util.getAuth()),
    "ACCESS_TOKEN": getACCESS_TOKEN()
  },
  responseType: 'json',
  withCredentials: true
});
// ----  接口定义开始-----
let defines = {

  /**
   * 手机号登录
   * @param params
   * @returns {AxiosPromise}
   */

  // login: (params) => { //
  //     let url = "/uc/login/mobile"
  //     return instance.post(url, params)
  // },
  /**
   * 获得省市区列表
   * @param parentid 省列表0, 市列表省code, 区列表市code, 街道列表区code, 村级地区列表街道code
   * @returns {AxiosPromise<any>}
   */
  getSSQList: (params) => {
    let url = '/dic/getSSQList'
    return register.get(url, {params: params})
  },
  getKSList: (params) => {//获取科室
    let url = '/management/dept/dictionary/normal'
    return customer.get(url, {params: params})
  },

  /**
   *management 管理相关模块
   */
  // 诊所信息
  clinicInfo: (params) => {
    let url = '/management/clinic'
    return customer.get(url, {params: params})
  },
  // 特色科室
  deptSpecial: (params) => {
    let url = '/management/dept/special'
    return customer.get(url, {params: params})
  },
  // 医生列表
  doctors: (params) => {
    let url = '/management/staff/doctors'
    return customer.get(url, {params: params})
  },
  productManage: (params) => {
    let url = '/product/manage'
    return customer.get(url, {params: params})
  },
  dean: (params) => {
    let url = '/management/staff/dean'
    return customer.get(url, {params: params})
  },
  // 诊所信息
  hisClinicList: (params) => {
    let url = '/management/clinic/list/normal'
    return customer.get(url, {params: params})
  },
  // 去医院的导航接口
  hospitalNav: (params) => {
    return customer.get('/dict/clinictype/byparent', {params: params})
  },
	//以下为最新去医院请求的接口
	//机构列表
	clincList: (params) => {
		let url = `/personnel/person/clin/getClincList`;
		return hospital.post(url,params)
	},
	//获取机构一级类型列表
	personnelLevel: () => {
		let url = `/personnel/clinic/type/list/onelevel`;
		return hospital.get(url)
	},    
	//获取机构二级类型列表
	secondLevel: (params) => {
	    let url = `/personnel/dept/list`;
	    return hospital.get(url + params)
	},
	//根据id获取机构详情
	getClincMessageById: (id) => {
	    let url = `/personnel/person/clin/getClincMessageById?id=${id}&latitude=''&longitude=''`;
	    return hospital.get(url)
	},
	//服务列表
	getDictProduct: (id) => {
	    let url = `/management/product/op-dict-product/list?clinicId=${id}`;
	    return hospital.get(url)
	},
	//查询去医院类目
	ategoryList: (params) => {
		return hospital.post('/commodity/prd/category/findDoctorFamilyCategoryList', params)
	},
	//查询去医院类目下的商品
	yProductList: (params) => {
		return hospital.post('/commodity/prd/product/findDoctorFamilyProductList', params)
	},
	//查询独家商品列表
	findProductFeaturesList: (params) => {
		return hospital.post('/commodity/prd/product/findProductFeaturesList', params)
	},        
}

let apis = {}
Object.keys(defines).forEach((name) => {
  apis[name] = function (params) {
    var req = defines[name](params)
    return req;
  };
});
export default apis



// WEBPACK FOOTER //
// ./src/lib/api.his.js